import React from 'react';

import styles from '../index.module.scss';

interface IImagePreview {
  url: string;
}

export const ImagePreview: React.FC<IImagePreview> = ({ url }) => (
  <div className={styles.content}>
    <img
      alt=""
      src={url}
    />
  </div>
);
